import { Routes } from '@angular/router';
import { ARRECADACAO_ROUTES } from '@/features/financeiro/arrecadacao/arrecadacao.constants';
import { permissionGuard } from '@/core/permissions/permission.guard';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';
import { arrecadacaoDashboardLandingGuard } from '@/features/financeiro/arrecadacao/dashboard-arrecadacao/dashboard-arrecadacao-landing.guard';

const R = ARRECADACAO_ROUTES;
const P = PERMISSOES.arrecadacao;

export const dashboardArrecadacaoRoutes: Routes = [
    {
        path: R.DASHBOARD,
        loadComponent: () => import('@/features/financeiro/arrecadacao/dashboard-arrecadacao/dashboard-arrecadacao').then((m) => m.DashboardArrecadacao),
        data: { breadcrumb: 'Dashboard' },
        children: [
            // Antes: redirect estático para 'pagamentos'. Quem só tinha creditos/boletos/... caía
            // em Sem acesso ao entrar pelo card (D1 libera o card por qualquer role do módulo).
            // Agora: aterrissa dinamicamente na primeira funcionalidade que o usuário alcança.
            { path: '', pathMatch: 'full', loadComponent: () => import('@/shared/components/layout/empty/empty').then((m) => m.Empty), canActivate: [arrecadacaoDashboardLandingGuard] },
            {
                path: R.PAGAMENTOS,
                loadComponent: () => import('@/features/financeiro/arrecadacao/dashboard-arrecadacao/components/grids/grid-pagamento/grid-pagamento').then((m) => m.GridPagamento),
                canActivate: [permissionGuard],
                data: { breadcrumb: 'Pagamentos', permission: P.pagamentos.escopo }
            },
            {
                path: R.CARTAO,
                loadComponent: () => import('@/features/financeiro/arrecadacao/dashboard-arrecadacao/components/grids/grid-cartao/grid-cartao').then((m) => m.GridCartao),
                canActivate: [permissionGuard],
                data: { breadcrumb: 'Cartão / PIX', permission: P.cartao.escopo }
            },
            {
                path: R.BOLETOS,
                loadComponent: () => import('@/features/financeiro/arrecadacao/dashboard-arrecadacao/components/grids/grid-boleto/grid-boleto').then((m) => m.GridBoleto),
                canActivate: [permissionGuard],
                data: { breadcrumb: 'Boletos', permission: P.boletos.escopo }
            },
            {
                path: R.CREDITOS,
                loadComponent: () => import('@/features/financeiro/arrecadacao/dashboard-arrecadacao/components/grids/grid-credito/grid-credito').then((m) => m.GridCredito),
                canActivate: [permissionGuard],
                data: { breadcrumb: 'Créditos', permission: P.creditos.escopo }
            },
            {
                path: R.ISENCOES,
                loadComponent: () => import('@/features/financeiro/arrecadacao/dashboard-arrecadacao/components/grids/grid-isencao/grid-isencao').then((m) => m.GridIsencao),
                canActivate: [permissionGuard],
                data: { breadcrumb: 'Isenções', permission: P.isencoes.escopo }
            },
            {
                path: R.ANOTACOES,
                loadComponent: () => import('@/features/financeiro/arrecadacao/dashboard-arrecadacao/components/anotacoes-dashboard/anotacoes-dashboard').then((m) => m.AnotacoesDashboard),
                canActivate: [permissionGuard],
                data: { breadcrumb: 'Anotações', permission: P.anotacoes.escopo }
            }
        ]
    }
];
